(function () {
  function initMarquee(section) {
    const slides = section?.querySelector('.announcement-bar__slides');
    if (!slides || slides.dataset.marqueeReady) return;

    const items = [...slides.children];
    if (!items.length) return;

    slides.classList.add('announcement-marquee-track');

    items.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      slides.appendChild(clone);
    });

    slides.style.setProperty(
      '--marquee-speed',
      `${section.dataset.marqueeSpeed || 20}s`
    );

    slides.dataset.marqueeReady = 'true';
  }

  const init = () =>
    document.querySelectorAll('.announcement-bar--marquee')
      .forEach(initMarquee);

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  document.addEventListener('shopify:section:load', e => {
    initMarquee(
      e.target.matches('.announcement-bar--marquee')
        ? e.target
        : e.target.querySelector('.announcement-bar--marquee')
    );
  });
})();
